// Use VITE_ENVIRONMENT instead of NODE_ENV for more accurate environment detection
const isDevelopmentEnvironment = () => {
    const viteEnv = import.meta.env.VITE_ENVIRONMENT;
    // Enable logging for Dev and Test environments
    return viteEnv === "Dev" || viteEnv === "Test" || !viteEnv; // Default to enabled if not set
};

const logger = {
    log: (...params) => {
        if (isDevelopmentEnvironment()) {
            console.log(...params);
        }
    },

    error: (...params) => {
        if (isDevelopmentEnvironment()) {
            console.error(...params);
        }
    },

    warn: (...params) => {
        if (isDevelopmentEnvironment()) {
            console.warn(...params);
        }
    },

    debug: (...params) => {
        if (isDevelopmentEnvironment()) {
            console.debug(...params);
        }
    },
};

export default logger;